import React from 'react'
import CardItem from './CardItem'
import CardItemSmall from './CardItemSmall'
import './Cards.css'

function Cards() {
  return (
    <div className='cards'>
      
      <div className='cards__container'>
        <div className='cards_wrapper'>
            <ul className='cards_items'>
                <CardItem 
                src="images/icon2.png"
                label='FLAGGY'
                path='https://play.google.com/store/apps/details?id=com.flagy.flagy&hl=en_US'
                text="Try FLAGGY now!"
                />
                <CardItemSmall
                src="images/fallball.png"
                label='Fall Ball'
                path='https://play.google.com/store/apps/details?id=com.FBall.fallball&hl=en_US'
                text="Try Fall Ball now!"
                />
                <CardItemSmall
                src="images/junny.png"
                label='Junny Bunny'
                path='https://play.google.com/store/apps/details?id=com.JunnyBunny.junnybunnyandroid'
                text="Try Junny Bunny now!"
                />
            </ul>
        </div>
        </div>

    </div>
  )
}

export default Cards
